import { ButtonType, Description, Heading, OverlayMode, Section, Button } from '@soteria/design-system-ve';

import * as styles from './CommunityGroupHeader.css.ts';

interface CommunityGroupHeaderProps {
  name: string;
  description?: string;
  isCommunityGroupAdmin: boolean;
  onAddCommunity: () => void;
}

export function CommunityGroupHeader({ name, description, isCommunityGroupAdmin, onAddCommunity }: CommunityGroupHeaderProps) {
  return (
    <Section spacing="medium">
      <Heading className={styles.groupDetailPageHeadingStyle} level="h1">
        {name}
      </Heading>

      {description && (
        <div className={styles.descriptionContainerStyle}>
          <Description>{description}</Description>
        </div>
      )}

      <div className={styles.actionsContainerStyle}>
        {isCommunityGroupAdmin && (
          <Button buttonType={ButtonType.Brand} overlayMode={OverlayMode.Solid} onClick={onAddCommunity}>
            ADD COMMUNITY
          </Button>
        )}
      </div>
    </Section>
  );
}
